"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.permissions = void 0;
exports.permissions = {
  role: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  invoice: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    },
    export: {
      all: {},
      my: {}
    }
  },
  products: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  discounts: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  participants: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  delivery: {
    read: {
      all: {}
    }
  },
  reports: {
    read: {
      all: {}
    }
  },
  reportsTax: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  paymentProviders: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  legalEntities: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  customFields: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  formBuilder: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  formScenarios: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  economicUnion: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  seasons: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  categories: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  options: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  payments: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  refunds: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  fulfillmentShipment: {
    read: {
      all: {}
    }
  },
  fulfillmentOperators: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  fulfillmentProducts: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  fulfillmentDelivery: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  fulfillmentRate: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    },
    import: {
      all: {}
    }
  },
  admin: {
    read: {
      all: {}
    }
  },
  countries: {
    read: {
      all: {}
    },
    update: {
      all: {}
    }
  },
  taxRates: {
    read: {
      all: {}
    },
    create: {
      all: {}
    },
    update: {
      all: {}
    },
    delete: {
      all: {}
    }
  },
  waitingList: {
    read: {
      all: {}
    }
  }
};